'use client'
import { useContext, useEffect, useRef } from 'react'
import { usePathname, useRouter } from 'next/navigation'
import { ModalsContext } from '@/context'
import { useProduct, useSession } from '@/hooks'
import { DY_COOKIE_GUEST_CART, DY_COOKIE_SESSION, DY_GUEST_CART_ALLOWED } from '@/utils'
import { useCart } from '@/context/project/CartContext'


// const LOGIN_LEVEL = IS_MMF_STORE ? 'login' : 'login_hm'
// const CLOSE_PRODUCT_PATHS = new Set(['/catalog', '/', '/welcome', '/brand'])

const normalizePathname = (path: string) => {
	if (path.length > 1 && path.endsWith('/')) return path.slice(0, -1)
	return path
}

export const UrlNavigationManager = () => {
	const { someModalIsActive } = useContext(ModalsContext)
	const { sessionChecked, customerToken, resetSession } = useSession()
	const { clearCart } = useCart()
	const { closeProduct, isActiveProduct } = useProduct()
	const previousPathnameRef = useRef<string | null>(null)
	// const { updatePayload: updateAuthPayload } = useModal(MODALS.AUTH)
	const pathname = usePathname()
	const { refresh } = useRouter()
	// const searchParams = useSearchParams()
	// const searchParamResetToken = searchParams.get('reset')
  // const searchParamInviteToken = searchParams.get('invite')
  // const searchParamModal = searchParams.get('modal')

	// const checkUrlSearchParams = useCallback(() => {
	// 	if (!DY_LOGIN_ALLOWED || customerToken) return
	// 	if (searchParamModal === 'login') {
	// 		updateAuthPayload({ payload: { level: LOGIN_LEVEL }, open: true })
  //   } else if (searchParamResetToken) {
  //     updateAuthPayload({ payload: { level: 'reset_password', resetToken: searchParamResetToken }, open: true })
  //   } else if (searchParamInviteToken) {
  //     updateAuthPayload({ payload: { level: 'activation', activationToken: searchParamInviteToken }, open: true })
  //   }
	// }, [searchParamInviteToken, searchParamModal, searchParamResetToken, updateAuthPayload, customerToken])

	// useEffect(() => {
	// 	checkUrlSearchParams()
	// // eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [])

	useEffect(() => {
		const html = document.body.parentElement
    html.style.overflow = someModalIsActive ? 'hidden' : 'visible'
	}, [pathname, someModalIsActive])

	useEffect(() => {
		if (!DY_GUEST_CART_ALLOWED) return
		if (!sessionChecked) return
		if (customerToken) return

		const guestToken = document.cookie.split('; ').find(row => row.startsWith(`${DY_COOKIE_GUEST_CART}=`))?.split('=')[1]
		if (!guestToken) clearCart()
	}, [sessionChecked, customerToken, clearCart, pathname])

	useEffect(() => {
		if (!sessionChecked) return
		if (!customerToken) return // already in guest state
		const hasSessionCookie = document.cookie
			.split('; ')
			.some(row => row.startsWith(`${DY_COOKIE_SESSION}=`))
		if (hasSessionCookie) return // cookie still present, nothing to do
		resetSession()
		clearCart()
		refresh()
	}, [pathname, sessionChecked, customerToken, resetSession, clearCart, refresh])

	useEffect(() => {
		const currentPathname = normalizePathname(pathname || '/')
		const previousPathname = previousPathnameRef.current
		const wasProductPath = !!previousPathname && normalizePathname(previousPathname).includes('/product/')
		const isProductPath = currentPathname.includes('/product/')

		if (isActiveProduct && wasProductPath && !isProductPath) closeProduct()

		previousPathnameRef.current = currentPathname
	}, [pathname, isActiveProduct, closeProduct])

	return null
}